// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-x39","label":"styles_label__3fgFK"};